import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface SidebarState {
  isVisible: boolean;
}

const initialState: SidebarState = {
  isVisible: false, // Mặc định sidebar đóng
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    openSidebar(state) {
      state.isVisible = true;
    },
    closeSidebar(state) {
      state.isVisible = false;
    },
    toggleSidebar(state) {
      state.isVisible = !state.isVisible;
    },
  },
});

export const sidebarActions = sidebarSlice.actions;

export const sidebarReducer = sidebarSlice.reducer;